import React from "react";
import AppTemplate from "../../component/app-template";
import PageNotFoundComponent from "../../component/errors-components/page-not-found";

const PageNotFound = () => {
  return (
    <AppTemplate
      pageTitle={"Page Not Found"}
      header={true}
      navbar={true}
      footer={true}
    >
      <PageNotFoundComponent />
    </AppTemplate>
  );
};

export default PageNotFound;
